import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InflightMealComponent } from './inflight-meal.component';
import { TextTooltipModule } from '@lib/components';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { FlightMealRequestModule } from '@app/my-booking/sub-components/my-booking-service/sub-components/flight-meal-request/flight-meal-request.module';
import { SelectMenuModule } from '../flight-meal-request/select-menu/select-menu.module';
import { TooltipDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [InflightMealComponent],
  imports: [
    CommonModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    TableSliderModule,
    StaticMsgModule,
    FlightMealRequestModule,
    AmountFormatModule,
    SelectMenuModule,
  ],
  exports: [InflightMealComponent],
})
export class InflightMealModule {}
